import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/main/Home';
import Hireink from './pages/Hireink';
import Projekt from './pages/projekt/Projekt';
import Magunkrol from './pages/magunkrol/Magunkrol';
import Navbar from './pages/main/Navbar';
import Celjaink from './pages/projekt/children/Celjaink';
import AHajokrol from './pages/projekt/children/a_hajokrol/AHajokrol';
import ProjektTortenet from './pages/projekt/children/projekt_tortenete/ProjektTortenet';
import DunaiHajok from './pages/projekt/children/a_hajokrol/children/DunaiHajok';
import Mohacs500 from './pages/projekt/children/Mohacs500';
import EgyebHajos from './pages/projekt/children/EgyebHajos';
import TerSegedlet from './pages/projekt/children/ter_segedlet/TerSegedlet';
import AttekintesAKorszakrol from './pages/projekt/children/ter_segedlet/children/AttekintesAKorszakrol';
import AdottTortenelmiPillanat from './pages/projekt/children/ter_segedlet/children/AdottTortenelmiPillanat';
import ProjekthezTampontokatAdo from './pages/projekt/children/ter_segedlet/children/ProjekthezTampontokatAdo';
import TargyiLeletek from './pages/projekt/children/ter_segedlet/children/TargyiLeletek';
import ProjektKezdetei from './pages/projekt/children/projekt_tortenete/children/projekt_kezdetei/ProjektKezdetei';
import HajoSzallag from './pages/projekt/children/projekt_tortenete/children/projekt_kezdetei/children/HajoSzallag';
import EgyeHajobanKapcs from './pages/projekt/children/projekt_tortenete/children/EgyHajobanKapcs';
import Salina from './pages/magunkrol/children/Salina';
import Kapcsolat from './pages/magunkrol/children/Kapcsolat';
import Partnereink from './pages/magunkrol/children/Partnereink';
import { useEffect } from 'react';

function App() {

    useEffect(() => {
      const img = new Image();
      img.src = process.env.PUBLIC_URL + '/assets/kereszt.png';
    }, []);
  return (
    <Router>
      <div className="nav-container col col-xl-8 offset-xl-2 offset-xxl-2">
      <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projekt" element={<Projekt />} />
            <Route path="/hireink" element={<Hireink />} />
            <Route path="/celjaink" element={<Celjaink />} />
            <Route path="/hajokrol" element={<AHajokrol />} />
            <Route path="/projekt-tortenet" element={<ProjektTortenet />} />
            <Route path='/projekt-kezdetei' element={<ProjektKezdetei/>} />
            <Route path='/egy-hajoban-kapcs' element={<EgyeHajobanKapcs/>} />
            <Route path="/mohacs-500" element={<Mohacs500 />} />
            <Route path="/egyeb-hajos" element={<EgyebHajos />} />
            <Route path="/ter-segedlet" element={<TerSegedlet />} />
            <Route path="/magunkrol" element={<Magunkrol />} />
            <Route path="/salina" element={<Salina />} />
            <Route path="/partnereink-tamogatoink" element={<Partnereink />} />
            <Route path="/kapcsolat" element={<Kapcsolat />} />
            <Route path="/hajoszallag" element={<HajoSzallag />} />
            <Route path="/attekintes-a-korszakrol" element={<AttekintesAKorszakrol />} />
            <Route path="/tanulmanyok" element={<AdottTortenelmiPillanat />} />
            <Route path="/projekt-tampontok" element={<ProjekthezTampontokatAdo />} />
            <Route path="/targyi-leletek" element={<TargyiLeletek />} />
            <Route path="/dunai-hajok" element={<DunaiHajok />} />
          </Routes>
      </div>
    </Router>
  );
}

export default App;
